import { HeaderController } from './header.controller'

/* @ngInject */
function header () {
  return {
    restrict: 'E',
    scope: {
      breadcrumbs: '<',
      navigation: '<',
      toolbar: '<',
      headerTitle: '<',
      hasFilter: '<',
      hasAdvancedFilterBtn: '<'
    },
    templateUrl: '/core/directives/header/header-directive.html?$$REVISION$$',
    controller: HeaderController
  }
}

export { header }
